<mat-grid-list [cols]="25" gutterSize="25px" rowHeight="350px" class="grid-list-space">
    <mat-grid-tile colspan="4" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Fixture Loc:</mat-label>
            </span>
            <mat-form-field style="margin-top: -12px; font-size:11px;" class="block">
                <mat-select #fixtureLocDropdown class="drop-down" [(ngModel)]="selectedTpr.fixtLocId"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('fixtLocId')"
                    (selectionChange)="onGenericFieldChange('fixtLocId',selectedTpr.fixtLocId,true)">
                    <mat-option *ngFor="let fixtureLoc of sources.fixtureLocs" [value]="fixtureLoc.id">
                        {{fixtureLoc.sourceName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>1st User Req:</mat-label>
            </span>
            <div style="margin-top: -5px;">
                <mat-form-field class="block">
                    <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker"
                        (dateChange)="onGenericFieldChange('fixtureRequired',selectedTpr.fixtureRequired, true)"
                        [(ngModel)]="selectedTpr.fixtureRequired" required
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('fixtureRequired')" />
                    <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #firstUserReqDatepicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Arrv 1st User:</mat-label>
            </span>
            <div style="margin-top: -5px;">
                <mat-form-field class="block">
                    <input matInput class="input-wrapper" [matDatepicker]="arrvFirstUserDatePicker"
                        (dateChange)="onGenericFieldChange('arrvTryout',selectedTpr.arrvTryout, true)"
                        [(ngModel)]="selectedTpr.arrvTryout"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('arrvTryout')" />
                    <mat-datepicker-toggle matSuffix [for]="arrvFirstUserDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #arrvFirstUserDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Arrv User Source:</mat-label>
            </span>
            <div style="margin-top: -5px;">
                <mat-form-field class="block"
                    matTooltip="Before entering an Arrv User Source date, enter an Arrv 1st User date or select NONE for 1st User Source.  In addition, it is necessary to enter an R-Study Passing date or enter N/A for R-Study Passing field.">
                    <input matInput class="input-wrapper" [matDatepicker]="arrvUserSourceDatePicker"
                        (dateChange)="onGenericFieldChange('arrvUserSrc',selectedTpr.arrvUserSrc, true)"
                        [(ngModel)]="selectedTpr.arrvUserSrc"
                        [disabled]="!firstUserDateEnabled() || disabled || reSourced || inActive || !fieldAuthorized('arrvUserSrc')" />
                    <mat-datepicker-toggle matSuffix [for]="arrvUserSourceDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #arrvUserSourceDatePicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="5" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Gage Design(%):</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.gaDesign" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gaDesign')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Gage Build(%):</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.gaBuild" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gaBuild')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Risk 1st User:</mat-label>
            </span>
            <div style="display: flex;">
                <mat-form-field class="block body-wrapper no-underline" [ngClass]="{
            'bg-green': getRisk1Calc() === RiskType.GREEN, 
            'bg-red': getRisk1Calc() === RiskType.RWOP || getRisk1Calc() === RiskType.RWP
        }">
                    <input matInput class="input-wrapper" [value]="getRisk1Calc()" readonly
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('r1')" />
                </mat-form-field>
                <mat-checkbox class="checkbox-format checkbox checkbox-risk" color="primary"
                    [(ngModel)]="this.selectedTpr.r1" (ngModelChange)="onRiskFirstUserCheckChange()" disableRipple
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('r1')">
                </mat-checkbox>
            </div>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Die Type:</mat-label>
            </span>
            <mat-form-field *ngIf="dieTypeEnabled()" class="block">
                <mat-select class="drop-down" [(ngModel)]="selectedTpr.progMake" (selectionChange)="onDieTypeChange()"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('progMake')">
                    <mat-option [value]="'Prog Die'">Prog Die</mat-option>
                    <mat-option [value]="'Make Die'">Make Die</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="!dieTypeEnabled()" class="block no-underline body-wrapper ">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('progMake')" />
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="4" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>JT Sent Sched:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.jTSentSched" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('jtSentSched')" />
            </mat-form-field>
            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>AVO Sched:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.avoSched"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('avoSched')" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Model Review Sched:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.mrRevSched"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mrRevSched')" readonly />
            </mat-form-field>
            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Math/JES Rev Sched:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.mathJesRevSched | date:'M/d/y'" disabled
                    readonly />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Adj (days):</mat-label>
            </span>
            <searchable-autocomplete style="margin-top: -12px;" [options]="daysOpts" [exactMatch]="false"
                [numberInput]="true" filterBy="designSource" [(selected)]="selectedTpr.designWeeksAdj"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designWeeksAdj')"
                (select)="onGenericFieldChange('designWeeksAdj',selectedTpr.designWeeksAdj, true)">
            </searchable-autocomplete>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="4" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>JT Sent Actual:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="block no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="jtSentActDatepicker"
                    [(ngModel)]="selectedTpr.jTSentAct"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('jtSentAct')"
                    (dateChange)="onGenericFieldChange('jTSentAct',selectedTpr.jTSentAct, false)" />
                <mat-datepicker-toggle matSuffix [for]="jtSentActDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #jtSentActDatepicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>AVO Actual:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="block no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="avoActDatepicker"
                    [(ngModel)]="selectedTpr.aVoAct"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('avoAct')"
                    (dateChange)="onGenericFieldChange('aVoAct',selectedTpr.aVoAct, false)" />
                <mat-datepicker-toggle matSuffix [for]="avoActDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #avoActDatepicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Model Review Actual:</mat-label>
            </span>
            <mat-form-field *ngIf="getTci()" class="block no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="mRevActDatepicker"
                    [(ngModel)]="selectedTpr.mRRevAct"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mrRevAct')"
                    (dateChange)="onGenericFieldChange('mRRevAct',selectedTpr.mRRevAct, false)" />
                <mat-datepicker-toggle matSuffix [for]="mRevActDatepicker"></mat-datepicker-toggle>
                <mat-datepicker class="bg-green" #mRevActDatepicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="!getTci()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Math/JES Rev Actual:</mat-label>
            </span>
            <mat-form-field *ngIf="!getEtac()" class="block no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="mathJesRevActDatepicker"
                    [(ngModel)]="selectedTpr.mathJesRevAct"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('mathJesRevAct')"
                    (dateChange)="onGenericFieldChange('mathJesRevAct',selectedTpr.mathJesRevAct, false)" />
                <mat-datepicker-toggle matSuffix [for]="mathJesRevActDatepicker"></mat-datepicker-toggle>
                <mat-datepicker class="bg-green" #mathJesRevActDatepicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="getEtac()" class="block body-wrapper no-underline">
                <input matInput class="input-wrapper" value="N/A" readonly
                    [disabled]="disabled || reSourced || inActive" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Adj (days):</mat-label>
            </span>
            <searchable-autocomplete style="margin-top: -12px;" [options]="daysOpts" [exactMatch]="false"
                [numberInput]="true" filterBy="buildSource" [(selected)]="selectedTpr.buildWeeksAdj"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildWeeksAdj')"
                (select)="onGenericFieldChange('buildWeeksAdj',selectedTpr.buildWeeksAdj, true)">
            </searchable-autocomplete>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="4" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Sched Start:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" (ngModel)="selectedTpr.designSchedStart"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designSchedStart')"
                    [ngModel]="selectedTpr.designSchedStart | date:'M/d/y'" readonly />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Actual Start:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="actualStartDatepicker"
                    [(ngModel)]="selectedTpr.designActualStart"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designActualStart')"
                    (dateChange)="onGenericFieldChange('designActualStart',selectedTpr.designActualStart, false)" />
                <mat-datepicker-toggle matSuffix [for]="actualStartDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #actualStartDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Sched Finish:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" (ngModel)="selectedTpr.designSchedFinish"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designSchedFinish')"
                    [ngModel]="selectedTpr.designSchedFinish | date:'M/d/y'" readonly />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Actual Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green"
                matTooltip="Before entering an Actual Finish date, each phase must be 100% complete.  In addition, an Actual Start date must be entered.">
                <input matInput class="input-wrapper" [matDatepicker]="actualFinishDatepicker"
                    [(ngModel)]="selectedTpr.designActualFinish"
                    [disabled]="!designActualFinishEnabled() || disabled || reSourced || inActive || !fieldAuthorized('designActualFinish')"
                    (dateChange)="onDesignActualFinishChanged()" />
                <mat-datepicker-toggle matSuffix [for]="actualFinishDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #actualFinishDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design F'cast Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="forecastFinishDatepicker"
                    [(ngModel)]="selectedTpr.designForecast"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designForecast')"
                    (dateChange)="onGenericFieldChange('designForecast',selectedTpr.designForecast, false)" />
                <mat-datepicker-toggle matSuffix [for]="forecastFinishDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #forecastFinishDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="4" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Sched Start:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" (ngModel)="selectedTpr.buildSchedStart"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildSchedStart')"
                    [ngModel]="selectedTpr.buildSchedStart | date:'M/d/y'" readonly />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Actual Start:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" [matDatepicker]="buildActualStartDatepicker"
                    [(ngModel)]="selectedTpr.buildActualStart"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildActualStart')"
                    (dateChange)="onGenericFieldChange('buildActualStart',selectedTpr.buildActualStart, false)" />
                <mat-datepicker-toggle matSuffix [for]="buildActualStartDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #buildActualStartDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Sched Finish:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" (ngModel)="selectedTpr.buildSchedFinish"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildSchedFinish')"
                    [ngModel]="selectedTpr.buildSchedFinish | date:'M/d/y'" readonly />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build Actual Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow"
                matTooltip="Before entering an Actual Finish date, each phase must be 100% complete.  In addition, an Actual Start date must be entered.">
                <input matInput class="input-wrapper" [matDatepicker]="buildActualFinishDatepicker"
                    [(ngModel)]="selectedTpr.buildActualFinish"
                    [disabled]="!buildActualFinishEnabled() || disabled || reSourced || inActive || !fieldAuthorized('buildActualFinish')"
                    (dateChange)="onBuildActualFinishChanged()" />
                <mat-datepicker-toggle matSuffix [for]="buildActualFinishDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #buildActualFinishDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Build F'cast Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-yellow">
                <input matInput class="input-wrapper" [matDatepicker]="buildForecastFinishDatepicker"
                    [(ngModel)]="selectedTpr.buildForecast"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildForecast')"
                    (dateChange)="onGenericFieldChange('buildForecast',selectedTpr.buildForecast, false)" />
                <mat-datepicker-toggle matSuffix [for]="buildForecastFinishDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #buildForecastFinishDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

    </mat-grid-tile>
</mat-grid-list>